import { Controller } from 'react-hook-form';
import { MuiTelInput } from 'mui-tel-input';
import { validatePhoneNumber } from '../../utils/validate';

interface IPhoneInputProps {
  error?: boolean,
  sx?: object,
  label: string,
  id: string,
  name: string,
  value?: string,
  require?: boolean,
  fullWidth?: boolean,
  className?: string,
  control?: any,
}

export const PhoneInput = ({
  control,
  label,
  name,
  id,
  fullWidth,
  sx,
  value,
  require = true,
  className,
  ...other
}: IPhoneInputProps): JSX.Element => (
  <Controller
    {...other}
    name={name}
    control={control}
    defaultValue={value}
    rules={{ validate: validatePhoneNumber(require) }}
    render={({ field, fieldState }) => (
      <MuiTelInput
        {...field}
        sx={sx}
        label={label}
        fullWidth={fullWidth}
        defaultCountry="AU"
        helperText={fieldState.invalid ? 'Phone number is not valid' : ''}
        error={fieldState.invalid}
        className={className}
      />
    )}
  />
);
